import { useEffect, useState, type CSSProperties } from 'react';
import { parseStoragePath, refreshStorageUrl } from '@/lib/storage';

interface Props {
  src: string | null | undefined;
  alt?: string;
  className?: string;
  style?: CSSProperties;
}

export function StorageImage({ src, alt = '', className, style }: Props) {
  const [resolved, setResolved] = useState<string | null>(src ?? null);

  useEffect(() => {
    if (!src) {
      setResolved(null);
      return;
    }
    if (!parseStoragePath(src)) {
      setResolved(src);
      return;
    }
    let active = true;
    void refreshStorageUrl(src)
      .then((url) => { if (active) setResolved(url); })
      .catch(() => { if (active) setResolved(src); });
    return () => { active = false; };
  }, [src]);

  if (!resolved) return null;
  return <img src={resolved} alt={alt} className={className} style={style} />;
}
